export default __webpack_public_path__ + "static/media/privacy-policy-kr-3.21cd8d96.jpg";